<div class="message-detail">
  <div class="message-detail-body" >
      <span [innerHtml]="messageContent | safeHtml"></span>
  </div>
</div>

 